import { render, staticRenderFns } from "./OutOrder.vue?vue&type=template&id=b2937ec4&lang=pug"
import script from "./OutOrder.vue?vue&type=script&lang=js"
export * from "./OutOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2937ec4')) {
      api.createRecord('b2937ec4', component.options)
    } else {
      api.reload('b2937ec4', component.options)
    }
    module.hot.accept("./OutOrder.vue?vue&type=template&id=b2937ec4&lang=pug", function () {
      api.rerender('b2937ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/orders/default/reports/OutOrder.vue"
export default component.exports